import { createContext, useContext } from 'react'
import { useCarrito } from '../hooks/useCarrito'

const CarritoCtx = createContext(null)

export function CarritoProvider({ children }) {
  const carrito = useCarrito()
  return <CarritoCtx.Provider value={carrito}>{children}</CarritoCtx.Provider>
}

export function useCarritoCtx() {
  return useContext(CarritoCtx)
}
